import React from 'react';
import { Banner } from './Banner';
import { ReleaseStatus } from '../interface';

type JobDetailsDeniedBannerProps = {
  requestKind?: ReleaseStatus;
  isExpired?: boolean;
  reasonMessage?: string | null;
};

export const JobDetailsDeniedBanner = ({
  requestKind,
  isExpired,
  reasonMessage,
}: JobDetailsDeniedBannerProps) => {
  const hasReason = (reasonMessage?.length ?? 0) > 0;
  const getMessage = () => {
    const kind = requestKind || 'swap';
    const status = isExpired ? 'expired' : 'declined';
    const capitalizedKind = kind.charAt(0).toUpperCase() + kind.slice(1);
    return `${capitalizedKind} request ${status}`;
  };

  return (
    <Banner
      bgColor="state.error.backing-1"
      iconColor="state.error.secondary"
      title={hasReason ? reasonMessage : getMessage()}
    />
  );
};
